import { render, staticRenderFns } from "./CathayWithYourHealth.vue?vue&type=template&id=4df31716"
import script from "./CathayWithYourHealth.vue?vue&type=script&lang=js"
export * from "./CathayWithYourHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports